import {Box, Button, styled} from '@mui/material';

const Container = styled(Box)`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: ${({theme}) => theme.spacing(2, 3)};
	background-color: ${({theme}) => theme.palette.grey[50]};
	border: 1px solid ${({theme}) => theme.palette.grey[200]};
	border-radius: 8px;
	margin: ${({theme}) => theme.spacing(4, 4, -1)};
	gap: ${({theme}) => theme.spacing(2)};

	${({theme}) => theme.breakpoints.down('sm')} {
		margin: ${({theme}) => theme.spacing(2, 2, 3)};
	}
`;

const TextWrapper = styled(Box)`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	flex: 1;
	min-width: 0;

	${({theme}) => theme.breakpoints.up('sm')} {
		gap: ${({theme}) => theme.spacing(0.5)};
	}
`;

const SealWrapper = styled(Box)`
	display: flex;
	align-items: center;
	flex-shrink: 0;
`;

const ButtonLink = styled(Button)`
	padding: 0;
	min-width: auto;
	line-height: initial;
	text-decoration: underline;

	&:hover {
		text-decoration: underline;
	}
`;

export {Container, SealWrapper, TextWrapper, ButtonLink};
